import {Injectable} from '@angular/core';
import {Popover} from 'primeng/popover';

@Injectable({providedIn: 'root'})
export class AdvancedOptionsPopoverCoordinatorService {
    private activePopover?: Popover;

    activate(popover: Popover): void {
        if (this.activePopover !== popover) {
            this.activePopover?.hide();
            this.activePopover = popover;
        }
    }

    release(popover: Popover): void {
        if (this.activePopover === popover) {
            this.activePopover = undefined;
        }
    }
}
